module.exports = __webpack_public_path__ + "static/media/land_rover.2d94bc21.png";